import { render, staticRenderFns } from "./VideoDisplay.vue?vue&type=template&id=f4549048&scoped=true"
import script from "./VideoDisplay.vue?vue&type=script&lang=js"
export * from "./VideoDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4549048",
  null
  
)

export default component.exports